import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {JbJobRunService} from '../../../service/api/jb-job-run.service';
import {JbJobStatusEnum} from '../../../enum/jb-job-status.enum';
import {Subscription} from 'rxjs';
import {JbJobRunDto} from '../../../model/dto/entity/jb-job-run.dto';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {DtoList} from '../../../../../core/shared/dto/dto.list';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';

@Component({
    selector: 'jb-job-status',
    templateUrl: 'jb-job-status.component.html',
    standalone: false
})

export class JbJobStatusComponent implements OnInit, OnChanges, OnDestroy {

    private sseSubscription: Subscription | null = null;

    counts: { total: number, errors: number, running: number} = {total: 0, errors: 0, running: 0};
    jobs: DtoList<JbJobRunDto>;

    busy: boolean;
    pendingLoad = false;

    constructor(protected jobRunService: JbJobRunService) {
    }

    ngOnInit() {

        // get initial counts
        this.listJobs();

        // subscribe for changes
        this.sseSubscription = this.jobRunService.getStreamJobUpdates().subscribe(value => {
            // something changed
            this.listJobs();
        });

    }

    listJobs() {

        if (this.busy) {
            this.pendingLoad = true;
            return;
        }
        this.busy = true;

        const filterCriteria = new FilterCriteria();

        // filterCriteria.addFilterCriteriaToOr(FilterCriteria.create('jobStatus', FilterCriteria.cOperatorEqual, JbJobStatusEnum.RUNNING));
        // filterCriteria.addFilterCriteriaToOr(FilterCriteria.create('jobStatus', FilterCriteria.cOperatorEqual, JbJobStatusEnum.ERROR));
        filterCriteria.addFilterCriteriaToAnd(FilterCriteria.create('startTime', FilterCriteria.cOperatorBetween, '${D-TODAY}', '9999-12-31'));

        const objectRequestList = ObjectRequestList.createBasic(false, [filterCriteria], []);

        this.jobRunService.list(objectRequestList).subscribe(res => {
            this.jobs = res;

            this.counts = {total: 0, errors: 0, running: 0};

            // implement count
            if (this.jobs) {
                for (let job of this.jobs.entries) {
                    this.counts.total += 1;
                    if (job.jobStatus == JbJobStatusEnum.RUNNING) {
                        this.counts.running += 1;
                    } else if (job.jobStatus == JbJobStatusEnum.ERROR) {
                        this.counts.errors += 1;
                    }
                }
            }

            this.busy = false ;
            if (this.pendingLoad) {
                this.pendingLoad = false;
                this.listJobs();
            }

        }, error => {
            this.busy = false;
        });

    }

    ngOnChanges(changes: SimpleChanges) {

    }

    ngOnDestroy() {

        if (this.sseSubscription != null) {
            this.sseSubscription.unsubscribe();
            this.jobRunService.closeStreamJobUpdates();
        }
    }

}
